<template>
    <div>
        <line-chart :chart-data="dataCollection" :options="chartOptions"></line-chart>
    </div>
</template>

<script>
    import LineChart from '@/components/LineChart.vue'

    export default {
        name: "AssessmentHistoryChart",
        components: { LineChart },
        props: {
            studentId: undefined,
            maxNumEntries: undefined,
            startDate: undefined,
            endDate: undefined
        },
        watch: {
            studentId(val, oldVal) {
                this.fillData();
            },
            maxNumEntries(val, oldVal) {
                this.fillData();
            },
            startDate(val, oldVal) {
                this.fillData();
            },
            endDate(val, oldVal) {
                this.fillData();
            },
        },
        data() {
            return {
                dataCollection: {},
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                suggestedMax: 100,    // minimum will be 0, unless there is a lower value.
                            }
                        }]
                    }
                }
            }
        },
        mounted() {
            this.fillData();
        },
        methods: {
            fillData() {
                this.$store.dispatch('searchHistory', {
                    studentIds: [this.studentId],
                    maxNumEntries: this.maxNumEntries || undefined,
                    startDate: this.startDate ? new Date(this.startDate) : undefined,
                    endDate: this.endDate ? new Date(this.endDate) : undefined,
                }).then((hList) => {
                    let assessmentIds = hList.map(h => h.assessmentId);

                    this.$store.dispatch('getAssessments', {
                        ids: assessmentIds
                    }).then((aList) => {
                        let labels = hList.map(h => {
                            let assessment = (aList && aList.length) ?
                                aList.find(a => a.assessmentId === h.assessmentId) :
                                undefined;
                            return `${assessment && assessment.title ? assessment.title : 'Unnamed'} - ${h.timestamp.toLocaleDateString()}`;
                        });
                        this.dataCollection = {
                            labels: labels,
                            datasets: [{
                                label: 'Test scores, in %',
                                fill: false,
                                borderColor: ['rgba(245, 130, 37, .6)'],
                                backgroundColor: 'rgba(245, 130, 37, 1)',
                                data: hList.map(h => h.countPercentageCorrect())
                            }]
                        };
                    });
                });
            }
        }
    }
</script>
